import { render, staticRenderFns } from "./EmptyListImageGroups.vue?vue&type=template&id=99dffe96&scoped=true"
var script = {}
import style0 from "./EmptyListImageGroups.vue?vue&type=style&index=0&id=99dffe96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dffe96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99dffe96')) {
      api.createRecord('99dffe96', component.options)
    } else {
      api.reload('99dffe96', component.options)
    }
    module.hot.accept("./EmptyListImageGroups.vue?vue&type=template&id=99dffe96&scoped=true", function () {
      api.rerender('99dffe96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/emptyListImages/EmptyListImageGroups.vue"
export default component.exports